import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'

interface ConfirmDeleteModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  userName: string
}

export function ConfirmDeleteModal({
  open,
  onClose,
  onConfirm,
  userName,
}: ConfirmDeleteModalProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirmar eliminação</DialogTitle>
      <DialogContent>
        <p>Tem a certeza que deseja eliminar o colaborador {userName}?</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  )
}
